module.exports = __webpack_public_path__ + "img/p9-p2-text.22d5330b.png";